import {
  IbgeCitiesResponseDTO,
  IbgeStatesResponseDTO
} from "@repo/core/services/entities/Ibge";
import { AxiosInstance, AxiosResponse } from "axios";

export class IbgeResource {
  apiProvider: AxiosInstance;

  constructor(instance: AxiosInstance) {
    this.apiProvider = instance;
  }

  async getStates(): Promise<AxiosResponse<IbgeStatesResponseDTO>> {
    return await this.apiProvider.get("/estados");
  }

  async getCities(uf: string): Promise<AxiosResponse<IbgeCitiesResponseDTO>> {
    return await this.apiProvider.get(`/estados/${uf}/municipios`);
  }
}
